module.exports = __webpack_public_path__ + "img/loader.10635db6.gif";